import React from "react";
import {PoweredByWrapper} from "./styles";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import logo from '../../../../assets/images/reservation/powered-by-logo.svg';

const PoweredByPickapier = () => {
    const {t} = useTranslation();
    return (
        <Link to="https://www.pickapier.com" target="_blank" style={{textDecoration: "none"}}>
            <PoweredByWrapper>
                <span>{t("POWERED_BY")}</span>
                <img src={logo} alt="pap-logo"/>
            </PoweredByWrapper>
        </Link>
    );
}

export default PoweredByPickapier;
